import {useFetchEmployment, useFetchIdentificationInfo} from '@rocket-ui/lk-api';
import {hasActiveEmploymentStatus} from 'features/registration';
import {resolveCompleteRegistrationEdit} from './identityVerification';
import {useProfile} from './useProfile';

/**
 * Пункты профиля, кроме баннеров и «Условия и правила»,
 * доступны после заполненных данных и хотя бы одного типа занятости.
 */
export function useProfileLinksUnlocked(): boolean {
	const {fullInfo, isSuccess: isProfileSuccess} = useProfile();
	const identificationInfo = useFetchIdentificationInfo();
	const employment = useFetchEmployment();

	if (!isProfileSuccess || !identificationInfo.isSuccess || employment.isLoading) {
		return false;
	}

	return (
		resolveCompleteRegistrationEdit(
			identificationInfo.data,
			fullInfo,
			hasActiveEmploymentStatus(employment.data),
		) === null
	);
}
